// This is Auth Reducer

const initState = {
    token: "",
    isLoading: false,
    isError: false,
  };
  
  export const reducer = (state = initState, { type, payload }) => {
    switch (type) {
      default:
        return state;
    }
  };
  